const endpointBasePath =
  "https://k8tbb61nv6.execute-api.us-east-2.amazonaws.com/dev";
export const classesEndpoint = `${endpointBasePath}/classes`;
export const agesEndpoint = `${endpointBasePath}/ages`;
export const levelsEndpoint = `${endpointBasePath}/levels`;
export const disciplinesEndpoint = `${endpointBasePath}/disciplines`;
export const locationsEndpoint = `${endpointBasePath}/locations`;
export const registrationEndpoint = `${endpointBasePath}/register`;
export const addTermEndpoint = `${endpointBasePath}/term`;
export const campsEndpoint = `${endpointBasePath}/camps`;
export const campAgesEndpoint = `${endpointBasePath}/campAges`;
